export default __webpack_public_path__ + "static/media/Arbre_de_la_vie_porte_cle_coeur.6d58f981.png";